/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { npDeptSigningFlows, npSigningFlows, rpDeptSigningFlows, rpSigningFlows } from './utils';
import { Button, Flex, Box, SimpleGrid } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import DataLoading from '../../components/DataLoading';
import Print from './components/print';
import c from '../../constant';

const Q_DETAIL = gql`
	query get($id: String!, $from: NpPreviewEnumType!) {
		getPreviewNpById(id: $id, from: $from) {
			id
			createdBy
			createdAt
			step
			number
			subject
			references
			description
			attachings
			attachments
			proposalNumber
			type
			office
			department
			completedAt
			createdByUser {
				id
				username
				fullName
				fullNameKhmer
				avatar
			}
			viewers {
				id
				createdAt
				createdBy
				userViewer {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
			}
			isDepartmentLevel
		}
	}
`;

const Q_SIGNS = gql`
	query getNpSigns($id: String!) {
		getNpSigns(id: $id) {
			id
			createdAt
			userCreatedBy {
				id
				username
				fullName
				fullNameKhmer
				avatar
			}
			createdBy
			position
			reviewer
			userReviewer {
				id
				username
				fullName
				fullNameKhmer
				avatar
				role
				position
				office
				department
			}
			decision
			decisionAt
			signature
			signatureImage
			miscellaneous
			decisionFile
		}
	}
`;

function Preview({ id = null, from = 'Proposal' | 'Relation', showButton = true, showBorder = false, isPreviewing = false }) {
	const { t } = useTranslation();
	const [npData, setNpData] = useState(null);
	const [npSigns, setNpSigns] = useState(null);
	const [loadDetail, { loading: loadingDetail, data: dataDetail }] = useLazyQuery(Q_DETAIL);
	const [loadSigns, { data: dataSigns }] = useLazyQuery(Q_SIGNS);

	useEffect(() => id && loadDetail({ variables: { id, from } }), [id]);

	useEffect(() => {
		if (dataDetail?.getPreviewNpById) {
			setNpData(dataDetail?.getPreviewNpById);
			loadSigns({ variables: { id: dataDetail?.getPreviewNpById?.id } });
		}
	}, [dataDetail]);

	useEffect(() => {
		if (dataSigns?.getNpSigns) {
			let localNpSigns = [];
			let positions =
				dataDetail?.getPreviewNpById?.type === 'rp'
					? dataDetail?.getPreviewNpById?.isDepartmentLevel
						? rpDeptSigningFlows
						: rpSigningFlows
					: dataDetail?.getPreviewNpById?.isDepartmentLevel
					? npDeptSigningFlows
					: npSigningFlows;
			positions.forEach((position) => {
				let npSigns = dataSigns?.getNpSigns?.filter((e) => e?.position === position);
				localNpSigns.push({
					position,
					data: npSigns[0] || null,
				});
			});
			setNpSigns(localNpSigns);
		}
	}, [dataSigns]);

	return (
		<>
			<DataLoading loading={loadingDetail} loadedData={npData}>
				{({ loadedData }) => (
					<center>
						<SimpleGrid mt={4} mb={8} columns={1} spacingY={4}>
							{showButton && (
								<Box className="hidden-print" width="100%">
									<Box maxW="960px">
										<Flex justifyContent="flex-end" alignItems="center">
											<Button
												onClick={window?.print}
												leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
												colorScheme="gray"
												variant="solid"
												size="sm"
												borderRadius={c.borderRadius}
												border="1px solid #bdc3c7"
											>
												{t('Print')}
											</Button>
										</Flex>
									</Box>
								</Box>
							)}
							<Box width="100%">
								<Print type={loadedData?.type} npData={loadedData} npSigns={npSigns} isPreviewing={isPreviewing} showBorder={showBorder} />
							</Box>
						</SimpleGrid>
					</center>
				)}
			</DataLoading>
		</>
	);
}

export default Preview;
